import { render } from "./courseMenuOld.vue?vue&type=template&id=233bbeac&scoped=true"
import script from "./courseMenuOld.vue?vue&type=script&lang=js"
export * from "./courseMenuOld.vue?vue&type=script&lang=js"

import "./courseMenuOld.vue?vue&type=style&index=0&id=233bbeac&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233bbeac"]])

export default __exports__